module.exports = __webpack_public_path__ + "customer7.png?1efc11499507592baf4f370e43383160";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/customer7.png
// module id = 119
// module chunks = 0